import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import LapPengeluaran from "../pages/laporan-bc/lap-pengeluaran";
import LapPemasukan from "../pages/laporan-bc/lap-pemasukan";
import LaporanStokBerjalan from "../pages/laporan-bc/lap-stok";
import LaporanMutasiBarang from "../pages/laporan-bc/lap-mutasi";

const PitaRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          <Route path="/customsreport/pemasukan" component={LapPemasukan} />
          <Route path="/customsreport/pengeluaran" component={LapPengeluaran} />
          <Route path="/customsreport/stok" component={LaporanStokBerjalan} />
          <Route path="/customsreport/mutasi" component={LaporanMutasiBarang} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default PitaRouter;
